<div class="position-relative">
  <div class="item-image">
    <!--Sponsor-->
    <ng-container *ngIf="auctionItem?.Sponsor?.SponsorImage">
      <div class="corner-icon-container-sponsor">
        <a target="_blank" href="{{ auctionItem?.Sponsor?.SponsorLink }}">
          <img src="{{ auctionItem?.Sponsor?.SponsorImage | contentImage: '6' : 'auction' }}" />
        </a>
      </div>
    </ng-container>
    <a class="auction" [owlRouterLink]="'/rewards/auctions/details/' + auctionItem.Id" [stopLink]="ignoreLink" id="auction-link">
      <div class="card loyalty border-0">
        <div class="position-relative">
          <ng-container [ngSwitch]="auctionItem.Status">
            <div *ngSwitchCase="auctionStatus.UserLosing" class="status outbid position-absolute text-center">
              <span>{{ 'auction.outbid.status' | translate }}</span>
            </div>
            <div *ngSwitchCase="auctionStatus.UserWinning" class="status winning position-absolute text-center">
              <span>{{ 'auction.winning.status' | translate }}</span>
            </div>
          </ng-container>

          <img
            class="card-img-top"
            src="{{ auctionItem.ImageUrl | contentImage: '7' : 'auction' }}"
            alt="{{ auctionItem.ItemName }}"
            [useDefault]="true"
            [loyaltyType]="'auction'"
            draggable="false"
          />
        </div>
      </div>
    </a>
  </div>
  <div
    class="rewards-status-separator align-items-center"
    [ngClass]="{ 'justify-content-between': !!statusText || !!stockAvailableStates }"
  >
    <ng-container *ngIf="statusText; else stockAvailableStates">
      <div class="rewards-item-panel-status {{ 'status-text-on-' + theme }}">{{ statusText | translate }}</div>
    </ng-container>
    <!--Item State-->
    <ng-template #stockAvailableStates>
      <ng-container *ngIf="stockAvailableState">
        <div class="rewards-item-panel-status  {{ textColor }}">
          <ng-container *ngIf="stockAvailableState == AUCTION_STATE.FEATURED">
            <span class="icon material-icons text-success font-size-20 me-1">{{ featuredIcon }}</span>
          </ng-container>
          <span class="item-state">{{ stockAvailableState | translate }}</span>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ifItemEnabled="auctionItem; disabledStatus: [state.COMING_SOON, state.SOLD_OUT]"
      ><fgbcl-countdown class="font-size-14 text-danger lotto-state-timer" [endDateTime]="auctionItem.EndDate"></fgbcl-countdown>
    </ng-container>
  </div>

  <div class="rewards-item-panel-name">{{ auctionItem.ItemName }}</div>

  <label class="accessibility-only">Points Value: </label>
  <div class="rewards-item-panel-value">{{ currentValue | FortressCurrencyPipe: 'PTS' }}</div>
</div>
